import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_sonner__ from "sonner";
import * as __WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__ from "../lib/SIcon.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__ from "./button.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__ from "../lib/utils.mjs";
import * as __WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__ from "lucide-react";
const actionIconMap = {
    "open-url": "open",
    close: "x",
    restore: "refresh",
    "custom-in-app": "play",
    "custom-placement": "bolt",
    purchase: "checkout",
    "set-product-index": "product",
    "set-state": "code"
};
const BaseToast = ({ title, description, icon, closeButton = true, onClose, action, cancel })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("p-4 w-full sm:w-[356px] flex items-center justify-between text-sm relative group/toast transition-all", description && "px-4 py-3"),
        children: [
            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("flex items-center gap-2.5", description && "gap-3"),
                children: [
                    icon,
                    /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                        className: "flex flex-col items-start justify-center",
                        children: [
                            /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                className: "text-foreground",
                                children: title
                            }),
                            description && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("p", {
                                className: "-mt-0.5 text-[13px] text-secondary-foreground",
                                children: description
                            })
                        ]
                    })
                ]
            }),
            (action || cancel) && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
                className: "flex gap-2 -my-1.5 -mr-1.5",
                children: [
                    cancel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        size: "sm",
                        variant: "ghost",
                        onClick: cancel.onClick,
                        children: cancel.label
                    }),
                    action && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__button_mjs_ee878bc8__.Button, {
                        size: "sm",
                        variant: "secondary",
                        onClick: action.onClick,
                        children: action.label
                    })
                ]
            }),
            closeButton && !action && !cancel && /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("button", {
                type: "button",
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("text-secondary-foreground transition-all opacity-0 group-hover/toast:opacity-70 group-hover/toast:transition-opacity hover:text-foreground duration-200 absolute cursor-pointer top-1.5 h-6 w-6 flex justify-center items-center right-1.5 p-0 bg-transparent border-0"),
                onClick: onClose,
                children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    type: "x",
                    className: "size-[11px]"
                })
            })
        ]
    });
const createToast = (props)=>__WEBPACK_EXTERNAL_MODULE_sonner__.toast.custom((t)=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(BaseToast, {
            ...props,
            onClose: ()=>__WEBPACK_EXTERNAL_MODULE_sonner__.toast.dismiss(t)
        }));
const sonner = Object.assign((props)=>createToast({
        ...props
    }), {
    message: (props)=>createToast({
            ...props
        }),
    info: (props)=>createToast({
            icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.Info, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(props.description ? "size-[21px]" : "size-[19px]", "text-blue-400 fill-blue-400/10", props.grayscale && "text-foreground fill-foreground/5")
            }),
            ...props
        }),
    success: (props)=>createToast({
            icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.CheckCircle2, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(props.description ? "size-[21px]" : "size-[19px]", "text-brand-primary fill-brand-primary/10", props.grayscale && "text-foreground fill-foreground/5")
            }),
            ...props
        }),
    warning: (props)=>createToast({
            icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.AlertTriangle, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(props.description ? "size-[21px]" : "size-[19px]", "text-amber-500 fill-amber-500/10", props.grayscale && "text-foreground fill-foreground/5")
            }),
            ...props
        }),
    error: (props)=>createToast({
            icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_lucide_react_f128bbbb__.XCircle, {
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)(props.description ? "size-[21px]" : "size-[19px]", "text-alert-primary fill-alert-primary/10", props.grayscale && "text-foreground fill-foreground/5")
            }),
            ...props
        }),
    loading: (props)=>createToast({
            icon: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                type: "spinner",
                className: (0, __WEBPACK_EXTERNAL_MODULE__lib_utils_mjs_6a3f3df3__.cn)("animate-spin text-foreground/50", props.description ? "!size-[19px]" : "!size-[17px] ")
            }),
            ...props
        }),
    promise: async (promise, { loading, success, error, ...props })=>{
        const id = sonner.loading({
            ...loading,
            ...props
        });
        try {
            const data = await promise;
            const successMessage = "function" == typeof success ? success(data) : success;
            sonner.success({
                ...successMessage,
                id,
                ...props
            });
            return data;
        } catch (err) {
            const errorMessage = "function" == typeof error ? error(err) : error;
            sonner.error({
                ...errorMessage,
                id,
                ...props
            });
            throw err;
        }
    },
    dismiss: __WEBPACK_EXTERNAL_MODULE_sonner__.toast.dismiss,
    propertyAction: (action, options)=>{
        const iconType = options?.iconType ?? "brand";
        const isEditor = "action" === iconType;
        return (0, __WEBPACK_EXTERNAL_MODULE_sonner__.toast)(/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("div", {
            style: {
                display: "flex",
                alignItems: "center",
                gap: 12,
                ...options?.style
            },
            children: [
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE__lib_SIcon_mjs_c59156f3__.SIcon, {
                    type: "brand" === iconType ? "logo-color" : actionIconMap[action.type],
                    className: "action" === iconType ? "text-brand-primary" : void 0,
                    size: "action" === iconType ? 16 : void 0
                }),
                /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)("span", {
                    children: [
                        "Tap triggered a",
                        " ",
                        /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ToastPill, {
                            isEditor: isEditor,
                            margins: {
                                right: true
                            },
                            children: action.type
                        }),
                        "purchase" === action.type ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsxs)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                            children: [
                                "for",
                                "by-index" === action.reference.type ? /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: options?.referenceNames?.[action.reference.index] || "unknown"
                                }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(ToastPill, {
                                    isEditor: isEditor,
                                    margins: {
                                        left: true
                                    },
                                    children: "selected"
                                })
                            ]
                        }) : /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(__WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.Fragment, {
                            children: "action"
                        }),
                        "."
                    ]
                })
            ]
        }));
    }
});
const ToastPill = ({ children, isEditor, margins })=>/*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("span", {
        style: {
            display: "inline-block",
            padding: isEditor ? "2px 6px" : "4px 6px",
            backgroundColor: "rgba(116, 255, 241, 0.15)",
            borderRadius: 7,
            color: "#74FFF1",
            textAlign: "center",
            marginRight: margins.right ? 4 : 0,
            marginLeft: margins.left ? 4 : 0
        },
        children: children
    });
export { sonner };
